<template>
  <div>
    <page-header :title="$t('bill.external_project_cost')">
      <div slot="res-status-tab" style="position: absolute; right: 0; top: 10px;">
        <bill-config :billShared.sync="billShared" :projectShared.sync="projectShared" :projectSharedShow="projectSharedShow" @update:currency="currencyChange" />
      </div>
    </page-header>
    <page-body>
      <cloud-externalproject-list :id="listId" :getParams="getParams" :billShared="billShared" :projectShared="projectShared" />
    </page-body>
  </div>
</template>

<script>
import shareMixin from '@Bill/mixins/share'
import BillConfig from '@Bill/sections/BillConfig'
import CloudExternalprojectList from './components/List'

export default {
  name: 'CloudExternalProjectIndex',
  components: {
    CloudExternalprojectList,
    BillConfig,
  },
  mixins: [shareMixin],
  data () {
    return {
      listId: 'CloudExternalProjectList',
    }
  },
  computed: {
    getParams () {
      // if (this.$store.getters.isDomainMode) {
      //   return {
      //     filter: `domain_id.equals(${this.$store.getters.userInfo.projectDomainId})`,
      //   }
      // }
      return {}
    },
  },
}
</script>
